import type { ReactNode } from "react";
import Tooltip from "./Tooltip";

interface FieldLabelProps {
  htmlFor?: string | undefined;
  children: ReactNode;
  /** Optional description shown as an info tooltip next to the label. */
  description?: string | undefined;
  className?: string | undefined;
}

/**
 * Shared form field label with an optional info tooltip (issue #72).
 * Keeps the label styling consistent across Create/Edit product pages.
 */
const DEFAULT_CLASS =
  "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1";

export default function FieldLabel({
  htmlFor,
  children,
  description,
  className,
}: FieldLabelProps) {
  const label = (
    <label htmlFor={htmlFor} className={className ?? DEFAULT_CLASS}>
      {children}
    </label>
  );

  if (!description) return label;

  return (
    <span className="flex items-center">
      {label}
      <Tooltip text={description} />
    </span>
  );
}
